function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.965 2.048a.49.49 0 01.422 0l3.951 1.889c.406.194.662.59.662 1.023v7.467c0 .85-.936 1.404-1.732 1.024l-3.092-1.479-4.141 1.98a.49.49 0 01-.422 0l-3.951-1.889A1.14 1.14 0 011 11.04V3.574c0-.85.936-1.404 1.732-1.023l3.092 1.478 4.141-1.98zM5.352 4.81L2.31 3.356c-.168-.08-.367.037-.367.217v7.466c0 .093.054.177.14.218l3.27 1.563V4.81zm.943 8.01l3.41-1.63V3.18l-3.41 1.63v8.01zm4.353-9.64v8.01l3.042 1.454c.168.08.367-.037.367-.217V4.96a.242.242 0 00-.14-.217l-3.27-1.563z",
  fill: "#2D2D2D"
});
function SvgMapa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Mapa.svg";
export { SvgMapa as ReactComponent };